<template>
  <div class="flex justify-center">
    <div
      v-for="index in maxProgress"
      :key="index"
      class="flex items-center"
    >
      <div
        :style="{
          backgroundColor: index <= progressInt ? `#${primaryColor}` : '#d4d4d8',
        }"
        class="w-[1.25rem] h-[1.25rem] rounded-full text-white text-xs flex justify-center items-center"
      >
        {{ index }}
      </div>

      <div
        v-if="index < 5"
        class="w-12 sm:w-24 h-1"
        :style="{
          backgroundColor: index < progressInt ? `#${primaryColor}` : '#d4d4d8',
        }"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  progress: {
    type: [String, Number],
    required: true,
  },

  primaryColor: {
    type: String,
    required: true,
  },

  maxProgress: {
    type: Number,
    required: false,
    default: 5,
  },
});

const progressInt = parseInt(props.progress);
</script>
